<dx-popup
    #codingDefaultPopup
    minWidth="150px"
    minHeight="150px"
    width="55%"
    height="50%"
    [title]="title"
    [showCloseButton]="true"
    [shading]="false"
    [showTitle]="true"
    [dragEnabled]="true"
    [resizeEnabled]="true"
    [closeOnOutsideClick]="false"
    [visible]="visible"
    (onShown)="onPopupShown()"
    (onHidden)="onPopupClose()"
>
    <div *dxTemplate="let data of 'content'">
        <dx-box *ngIf="codingDefaultEditor" width="100%" height="100%" direction="col">
            <dxi-item baseSize="auto">
                <div *dxTemplate>
                    <dx-form width="100%" height="100%" [colCount]="2">
                        <dxi-item>
                            <dxo-label text="Special Handling"></dxo-label>
                            <div *dxTemplate>
                                <dx-select-box
                                    displayExpr="displayText"
                                    valueExpr="specialHandlingId"
                                    [showClearButton]="true"
                                    [searchEnabled]="true"
                                    [dataSource]="codingDefaultEditor?.specialHandlings"
                                    [(value)]="headerTemplate.specialHandlingId"
                                ></dx-select-box>
                            </div>
                        </dxi-item>
                        <dxi-item>
                            <dxo-label text="Bank Account"></dxo-label>
                            <div *dxTemplate>
                                <app-multi-column-selector
                                    [name]="'Bank Account'"
                                    [gridSource]="codingDefaultEditor?.bankAccounts"
                                    [boxValue]="bankAccountBoxValue"
                                    [valueExpr]="'bankAccountId'"
                                    [displayExpr]="'displayBankName'"
                                    [columnDef]="bankAccountColumns"
                                    [dropDownButtonTemplate]="'dropDownButton'"
                                    [showClearButton]="true"
                                    [cssClass]="'bank-account-drop-down-box'"
                                    [dropDownOptions]="{ width: 'auto' }"
                                    [placeholder]="'Select Bank Account...'"
                                    (gridSelectionEvent)="onBankAccountSelection($event)"
                                ></app-multi-column-selector>
                            </div>
                        </dxi-item>
                        <dxi-item [colSpan]="2">
                            <dxo-label text="Description"></dxo-label>
                            <div *dxTemplate>
                                <dx-text-box [(value)]="headerTemplate.description"></dx-text-box>
                            </div>
                        </dxi-item>
                    </dx-form>
                </div>
            </dxi-item>
            <dxi-item [ratio]="1">
                <div *dxTemplate>
                    <dx-box width="100%" height="100%" direction="col">
                        <dxi-item baseSize="auto">
                            <div *dxTemplate>
                                <dx-toolbar width="100%" class="button-container">
                                    <dxi-item location="after">
                                        <dx-button
                                            type="default"
                                            text="Add New Line Item"
                                            [icon]="iconPlus"
                                            (onClick)="onAddNewLineItem()"
                                        ></dx-button>
                                    </dxi-item>
                                </dx-toolbar>
                            </div>
                        </dxi-item>
                        <dxi-item [ratio]="1">
                            <div *dxTemplate>
                                <dx-data-grid
                                    #codeEditorLineItemGrid
                                    ccAddNewRow
                                    width="100%"
                                    height="100%"
                                    keyExpr="itemId"
                                    [highlightChanges]="true"
                                    [repaintChangesOnly]="true"
                                    [allowColumnReordering]="true"
                                    [allowColumnResizing]="true"
                                    [showBorders]="true"
                                    [showColumnLines]="true"
                                    [showRowLines]="true"
                                    [dataSource]="gridLineItems"
                                    (onRowUpdated)="onRowUpdated($event)"
                                    (onAddNewRow)="onAddNewLineItem()"
                                >
                                    <dxo-editing
                                        mode="cell"
                                        refreshMode="full"
                                        [selectTextOnEditStart]="true"
                                        [allowUpdating]="true"
                                        [useIcons]="true"
                                    ></dxo-editing>

                                    <dxi-column
                                        caption="Action"
                                        alignment="center"
                                        cellTemplate="actionCellTemplate"
                                        [allowEditing]="false"
                                        [width]="50"
                                    ></dxi-column>
                                    <dxi-column
                                        dataField="enabled"
                                        dataType="boolean"
                                        caption="Active"
                                        alignment="center"
                                        editCellTemplate="enabledEditTemplate"
                                        [width]="110"
                                        [showEditorAlways]="true"
                                        [allowSorting]="false"
                                        [allowEditing]="true"
                                    ></dxi-column>
                                    <dxi-column
                                        dataType="number"
                                        caption="Item #"
                                        cellTemplate="itemNumber"
                                        [width]="70"
                                        [allowEditing]="false"
                                    ></dxi-column>
                                    <dxi-column
                                        dataType="string"
                                        dataField="subAccountId"
                                        caption="GL Account"
                                        editCellTemplate="glAccountTemplate"
                                        [width]="250"
                                        [showEditorAlways]="true"
                                        [allowSorting]="false"
                                        [allowEditing]="true"
                                    >
                                        <dxo-lookup
                                            [dataSource]="codingDefaultEditor?.glAccounts"
                                            displayExpr="displayText"
                                            valueExpr="subAccountID"
                                        ></dxo-lookup>
                                    </dxi-column>
                                    <ng-container *ngIf="codingDefaultEditor?.entityUsesSubcategory">
                                        <dxi-column
                                            dataField="subCategoryId"
                                            dataType="string"
                                            caption="Sub Category"
                                            [width]="180"
                                            editCellTemplate="subCategoryTemplate"
                                            [showEditorAlways]="true"
                                            [allowSorting]="false"
                                            [allowEditing]="true"
                                        ></dxi-column>
                                    </ng-container>
                                    <dxi-column
                                        dataType="number"
                                        dataField="itemAmount"
                                        caption="Amount"
                                        [width]="70"
                                        [format]="currencyFormat"
                                    ></dxi-column>
                                    <ng-container *ngFor="let col of codingDefaultEditor?.dimensions">
                                        <dxi-column
                                            dataType="string"
                                            allowSorting="false"
                                            headerCellTemplate="dimensionHeaderTemplate"
                                            editCellTemplate="dimensionCellTemplate"
                                            width="140"
                                            [showEditorAlways]="true"
                                            [dataField]="col.code"
                                            [caption]="col.text"
                                        ></dxi-column>
                                    </ng-container>
                                    <dxi-column
                                        dataType="string"
                                        dataField="description"
                                        width="140"
                                        caption="Description"
                                    ></dxi-column>

                                    <div *dxTemplate="let header of 'dimensionHeaderTemplate'">
                                        {{ header.column.caption }}
                                    </div>
                                    <div *dxTemplate="let cellInfo of 'dimensionCellTemplate'">
                                        <dx-select-box
                                            displayExpr="text"
                                            valueExpr="code"
                                            [dataSource]="cellInfo.data[cellInfo.column.dataField + '_source']"
                                            [(value)]="cellInfo.data[cellInfo.column.dataField]"
                                            (onValueChanged)="onDimensionValueChanged($event, cellInfo)"
                                        ></dx-select-box>
                                    </div>

                                    <div *dxTemplate="let item of 'itemNumber'">
                                        <span>
                                            {{ item.row.rowIndex + 1 }}
                                        </span>
                                    </div>

                                    <div *dxTemplate="let d of 'actionCellTemplate'">
                                        <i
                                            class="cc-1-5x icon-content cc-red-icon"
                                            [ngClass]="iconDelete"
                                            (click)="onDeleteLineItemClick(d.data)"
                                        ></i>
                                    </div>

                                    <div *dxTemplate="let cellInfo of 'glAccountTemplate'">
                                        <app-grid-cell-multi-column-selector
                                            [name]="'GL Accounts'"
                                            [gridSource]="codingDefaultEditor.glAccounts"
                                            [cellInfo]="cellInfo"
                                            [dropDownButtonTemplate]="'dropDownButton'"
                                            [dropDownOptions]="{ width: 250 }"
                                            [valueExpr]="'subAccountID'"
                                            [displayExpr]="'displayText'"
                                            [columnDef]="glAccountColumns"
                                            [showClearButton]="true"
                                            [placeholder]="'Select GL Account...'"
                                            (gridSelectionEvent)="onGLAccountSelection($event.selectedRow, cellInfo)"
                                        ></app-grid-cell-multi-column-selector>
                                    </div>

                                    <div *dxTemplate="let cellInfo of 'subCategoryTemplate'">
                                        <dx-select-box
                                            displayExpr="title"
                                            valueExpr="id"
                                            noDataText="No sub categories configured"
                                            [searchEnabled]="true"
                                            [dataSource]="cellInfo.data.subCategorySource"
                                            [(value)]="cellInfo.data.subCategoryId"
                                            (onValueChanged)="onSubcategoryValueChanged($event, cellInfo)"
                                        ></dx-select-box>
                                    </div>

                                    <div *dxTemplate="let cellInfo of 'enabledEditTemplate'">
                                        <dx-check-box
                                            [(value)]="cellInfo.data.enabled"
                                            (onValueChanged)="onEnabledValueChanged($event, cellInfo)"
                                        ></dx-check-box>
                                    </div>

                                    <dxo-summary [calculateCustomSummary]="calculateCustomSummary">
                                        <dxi-total-item
                                            column="itemAmount"
                                            name="itemAmount"
                                            summaryType="custom"
                                            [valueFormat]="currencyFormat"
                                            displayFormat="{0}"
                                        ></dxi-total-item>
                                    </dxo-summary>
                                </dx-data-grid>
                            </div>
                        </dxi-item>
                    </dx-box>
                </div>
            </dxi-item>
            <dxi-item baseSize="auto">
                <div *dxTemplate>
                    <dx-toolbar width="100%" class="button-container">
                        <dxi-item location="before">
                            <dx-button
                                type="default"
                                text="Cancel"
                                [icon]="iconCancel"
                                (onClick)="onPopupClose()"
                            ></dx-button>
                        </dxi-item>
                        <dxi-item location="after">
                            <dx-button
                                type="success"
                                text="Save"
                                [icon]="iconSave"
                                (onClick)="onSaveClick()"
                            ></dx-button>
                        </dxi-item>
                    </dx-toolbar>
                </div>
            </dxi-item>
        </dx-box>
    </div>
</dx-popup>

<cc-message-box #codingDefaultMessageBox></cc-message-box>

<dx-load-panel
    [position]="{ of: '#codingDefaultPopup' }"
    *ngIf="loadingVisible"
    [visible]="loadingVisible"
    [showIndicator]="true"
    [showPane]="true"
    [shading]="true"
    [closeOnOutsideClick]="false"
></dx-load-panel>
